import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  labelStyle: {
    cursor: "pointer",
  },
  fileStyle: {
    display: "none",
  },
});

export default useStyles;
